import { ArrowBack as IconArrowBack } from "@mui/icons-material";
import { IconButton, Skeleton, Stack, Typography } from "@mui/material";
import { generatePath, Link, To } from "react-router";

import { GaiaSubtleLink } from "~/modules/app/components/GaiaSubtleLink";

import { VisitDetailPanelHeaderAreaFragment } from "./fragments.generated";

type VisitDetailPanelHeaderProps = {
    area?: VisitDetailPanelHeaderAreaFragment;
    loading: boolean;
    backHref: To;
};

export function VisitDetailPanelHeader({ area, loading, backHref }: VisitDetailPanelHeaderProps) {
    return (
        <>
            <IconButton component={Link} color="inherit" to={backHref} sx={{ marginInlineEnd: 1 }}>
                <IconArrowBack />
            </IconButton>

            {loading && area === undefined ? (
                <Stack flexGrow={1}>
                    <Skeleton variant="text" width="60%" height={16} sx={{ marginBottom: 0.5 }} />
                    <Skeleton variant="text" width="80%" height={28} />
                </Stack>
            ) : (
                area !== undefined && (
                    <Stack>
                        <Typography variant="caption">
                            <GaiaSubtleLink
                                to={generatePath("/c/:clientSlug", { clientSlug: area.project.client.slug })}
                            >
                                {area.project.client.name}
                            </GaiaSubtleLink>{" "}
                            •{" "}
                            <GaiaSubtleLink
                                to={generatePath("/c/:clientSlug/p/:projectSlug", {
                                    clientSlug: area.project.client.slug,
                                    projectSlug: area.project.slug,
                                })}
                            >
                                {area.project.name}
                            </GaiaSubtleLink>
                        </Typography>
                        <Typography variant="h6">
                            <GaiaSubtleLink
                                to={generatePath("/c/:clientSlug/p/:projectSlug/map-editor", {
                                    clientSlug: area.project.client.slug,
                                    projectSlug: area.project.slug,
                                })}
                            >
                                {area.name}
                            </GaiaSubtleLink>
                        </Typography>
                    </Stack>
                )
            )}
        </>
    );
}
